/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const Wrapper = styled(Box)(({theme}) => ({
  width: '100%',
  height: '100%',
  border: `1px solid ${theme.palette.figma_gray_dark_3?.main}`,
  borderRadius: '8px',
  padding: theme.spacing(4),
}));

export const Text = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.figma_gray_light_1?.main,
}));
